module.exports = __webpack_public_path__ + "img/denmark-other-heart-diseases-male.0bff8dd2.png";